<template>
  <div v-if="orderCompleteDetails" :style="`height: 70vh; position: relative; text-align: center; color: ${orderCompleteDetails.color || 'red'}`">
    <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
      <div>
        <i :class="(orderCompleteDetails.icon || 'fas fa-times') + ' fa-10x'"></i>
      </div>
      <div style="font-size: 200%; margin-top: 20px">
        {{ $t( orderCompleteDetails.message || 'Orders.noOrders' )}}
      </div>
    </div>
  </div>
  <div ui-view v-else>
    <confirm-popup
      v-if="$root.deleteProjectConfirmation"
      :text="$t($root.deleteProjectConfirmation.text)"
      acceptlLabel="Action.delete"
      ref="deletePopup"
      @accept="removeProject"
    />
    <order-messages
      v-if="hasReference"
      :transactionnum="reference.transaction.transactionnum"
      :order-id="reference.transaction.ID"
      ref="messages"
    ></order-messages>
    <new-order
      ref="newOrder"
      v-on:ordercreated="openOrder"
      :project-id="projectId"
      :cart-sections="cartSections"
      :form="orderDialogForm"
    ></new-order>
    <new-addon
      ref="newAddon"
      v-on:additem="handleNewAddon"
      v-on:removeitem="handleRemoveAddon"
    ></new-addon>
    <upload-stl
      ref="uploader"
      :project-id="projectId"
      :product-tree="productTree"
      v-show="uploadStl"
      v-on:save="appendFiles"
      v-on:goback="closeUploader"
    ></upload-stl>
    <jaw-editor
      ref="jawedit"
      :model-tree="modelTree"
      v-show="editJaw"
      v-on:save="updateConstruction"
      v-on:goback="closeJawEditor"
    ></jaw-editor>
    <project-tooth-selector-popup ref="picker"></project-tooth-selector-popup>
    <div ui-view v-if="!uploadStl && !editJaw">
      <div v-if="alertTitle" class="row">
        <div class="col-md-12">
          <alert
            :title="alertTitle"
            :color="alertStyle"
            :text="alertText"
            :icon="alertIcon"
            :dismissable="!alertCritical"
            v-on:dismiss="closeAlert"
          ></alert>
        </div>
      </div>
      <div v-if="hasOrder && !$root.isEmbeddedMode" class="row">
        <div class="col-md-12">
          <alert
            color="success"
            :title="$t('ProjectDetails.alertOrdered')"
            icon="truck"
            :text="order.transactionnum"
          >
            {{ order.transactionnum }}, {{ order.date | formatDate }}
            <button type="button" class="btn btn-info btn-xs mleft-20" v-on:click="openOrder(order.ID)">{{ $t('ProjectDetails.openOrder') }}</button>
          </alert>
        </div>
      </div>

      <div v-if="hasReference && reference.name && !$root.isEmbeddedMode" class="row">
        <div class="col-md-12">
          <alert
            color="info"
            :title="$t('ProjectDetails.alertReference')"
            icon="link"
            icon-prefix="fas"
            :text="reference.name"
          >
            {{ reference.name }}, {{ reference.lastmodified | formatDate }}
            <a type="button" class="btn btn-info btn-xs mleft-20" :href="getReferenceUrl(reference.ID)" target="_blank">{{ $t('ProjectDetails.openProject') }}</a>
          </alert>
        </div>
      </div>

      <div v-if="customerInfoVisibility" class="row">
        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" v-if="customerShippingInfoVisibility && deliveryAddressDetails">
          <addresscard
                  :firstname="deliveryAddressDetails.firstname"
                  :lastname="deliveryAddressDetails.lastname"
                  :address="deliveryAddressDetails.address"
                  :postalcode="deliveryAddressDetails.postalcode"
                  :city="deliveryAddressDetails.city"
                  :region="deliveryAddressDetails.region"
                  :country="deliveryAddressDetails.country"
                  :phone="deliveryAddressDetails.phone"
                  :phone2="deliveryAddressDetails.phone2"
                  :editable="false"
                  :removable="false"
                  :selectable="false"
                  :changable="false"
                  :is-shipping="1"
          ></addresscard>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" v-if="customerBillingInfoVisibility && orderDetails.billingrecipient">
          <addresscard
                  :lastname="orderDetails.billingrecipient"
                  :address="orderDetails.billingaddress"
                  :postalcode="orderDetails.billingpostalcode"
                  :city="orderDetails.billingcity"
                  :region="orderDetails.billingregion"
                  :country="orderDetails.billingcountry"
                  :editable="false"
                  :removable="false"
                  :selectable="false"
                  :changable="false"
                  :is-billing="1"
          ></addresscard>
        </div>
      </div>

      <template v-if="!alertCritical">
        <div class="row" :key="renderId">
          <div class="col-md-12">
            <card
              :title="$t(title)"
              :icon="icon"
              :icon-prefix="iconPrefix"
              :icon-color="iconColor"
              :loader="activeRequest"
              body-class="nopadding"
              :key="type"
            >
              <template slot="buttons" v-if="!hasOrder && isEditable">
                <button v-if="workflowType.deletable !== false" type="button" class="btn btn-danger" v-on:click="confirmProjectRemove"><i class="fa fa-trash"></i> {{ $t('Action.remove') }}</button>
                <button type="submit" class="btn btn-success" v-on:click="saveProject" :disabled="!isModified"><i class="fa fa-check"></i> {{ $t('Action.save') }}</button>
              </template>

              <card :blend="activeRequest" v-on:change="handleChangeTab" :active-tab="activeTab" :is-print-view="isPrintView">
                <cardtab v-for="(tab, index) in tabs"
                         :title="$t(tab.title || ('tab ' + index))"
                         :id="`${tab.id || index}`"
                         :key="`tab_${tab.id || index}`"
                         :ref="`tab_${tab.id || index}`"
                         :icon="tab.icon"
                         :icon-prefix="tab.iconPrefix"
                         :badge="getBadge(tab.id || index)"
                         :badge-color="getBadgeColor(tab.id || index)"
                         :class="getTabClass(tab, tab.id || index)"
                         v-if="isAvailable(tab)"
                >
                  <h3 class="nav-buttons-container" v-if="isPrintView">
                    {{$t(tab.title || ('tab ' + index))}}
                  </h3>

                  <div v-if="getTabCustomError(tab.id || index)" class="alert alert-danger" v-html="getTabCustomError(tab.id || index)" ></div>

                  <template v-for="block in getBlocks(tab.intro)">
                    <div v-if="showBlock(block)" :class="block.style" v-html="$t(block, formValues)" ></div>
                  </template>

                  <project-master-data-tab v-if="tab.form && tab.type !== 'approval'"
                                           :classes="tab.type === 'cart' ? 'pad-15' : ''"
                                           :form="tab.form"
                                           :formValues="formValues"
                                           :itemNums="itemNums"
                                           :itemNumsAll="itemNumsAll"
                                           :ext-data="extdata"
                                           :hasOrder="hasOrder"
                                           :isEditable="isEditable"
                                           ref="tab_content"
                                           :force-validation="(badges[`tab_form_${tab.id || index}`] || {}).attempted"
                                           v-on:input="handleFormInput"
                                           v-on:valid="(isValid) => handleFormStatus(`tab_form_${tab.id || index}`, isValid)"
                  >
                  </project-master-data-tab>

                  <component
                          v-if="tab.component"
                          v-bind:is="tab.component"
                          ref="tab_content"
                          :form-values="formValues"
                          :item-nums="itemNums"
                          :item-nums-all="itemNumsAll"
                          :has-order="hasOrder"
                          :is-editable="isEditable"
                          :force-validation="(badges[`tab_${tab.id || index}`] || {}).attempted"
                          :config="tab"
                          :workflow-type="workflowType"
                          :cart-items="cartSections"
                          :project-id="projectId"
                          :cart-notice="cartNotice"
                          v-on:input="handleFormInput"
                          v-on:valid="(isValid) => handleFormStatus(`tab_${tab.id || index}`, isValid)"
                  />

                  <tab-attachments v-else-if="tab.type === 'attachments'"
                                   :baseUrl="projectUrl"
                                   :readonly="hasOrder || $root.isEmbeddedMode"
                                   :classes="tab.classes"
                                   :form="tab.form"
                                   :formValues="formValues"
                                   :itemNums="itemNums"
                                   :itemNumsAll="itemNumsAll"
                                   :fileLimit="tab.fileLimit"
                                   :sizeLimit="tab.sizeLimit"
                                   :fileTypes="tab.fileTypes"
                                   :file-names="tab.fileNames"
                                   :error-message="tab.errorMessage"
                                   :dropzone-height="tab.height"
                                   :requirements="fileRequirements"
                                   :attachments-requirements-hints="getAllMissingRequirementsMsgs()"
                                   :allow-post-upload="allowUpload"
                                   ref="tab_content"
                                   @uploaded="handleAttachment"
                                   @error="handleAttachmentError"
                                   @valid="(isValid) => handleTabStatus(`tab_${tab.id || index}`, isValid)"
                  >
                  </tab-attachments>

                  <project-tooth-selector-tab v-else-if="tab.type === 'selector'"
                                              :layers="tab.layers || []"
                                              :formValues="formValues"
                                              :itemNums="itemNums"
                                              :itemNumsAll="itemNumsAll"
                                              :readonly="hasOrder"
                                              :key="projectId"
                                              :is-printout="isPrintView"
                                              :teeth-view="tab.teethView || 'top'"
                                              ref="tab_content"
                                              @change="handleToothSelectorChange"
                                              @popup="([m, d, e, h]) => $refs.picker.openDialog(m, d, e, h)"
                                              @valid="(isValid) => handleTabStatus(`tab_${tab.id || index}`, isValid)"
                  >
                  </project-tooth-selector-tab>

                  <div v-else-if="tab.type === 'addons'">
                    <div class="ptop-10 pright-10 pleft-10" v-if="addonNoticeMsg">
                      <div class="alert alert-warning">
                        <i class="fas fa-info-circle"></i> {{ addonNoticeMsg }}
                      </div>
                    </div>
                    <product-addons
                        ref="addons"
                        v-on:itemclick="handleAddonItemClick"
                        :category-picker="tab.categoryPicker"
                        :initial-category="tab.category"></product-addons>
                  </div>

                  <div v-else-if="tab.type ==='construction'" class="row">
                    <div class="col-xs-12 col-sm-5 col-md-6 col-lg-6 a-c">
                      <img v-if="jawImage" :src="jawImage" :alt="$t('ProjectDetails.construction')" class="img-responsive center-block" v-on:click="openJawEditor" />
                      <div v-if="!jawImage" class="jawpreview" v-on:click="openJawEditor"></div>
                    </div>
                    <div class="col-xs-12 col-sm-7 col-md-6 col-lg-6">
                      <h3 v-if="hasTeeth">{{ $t('ProjectDetails.toothSelection') }}</h3>
                      <teeth-list :teeth="teeth.groups" :editable="false" :showPrices="false">
                        <div class="empty-indicator">
                          {{ $t('ProjectDetails.noConstruction') }}
                        </div>
                      </teeth-list>
                      <div class="a-c" v-if="!hasOrder">
                        <button type="button" class="btn btn-primary" v-on:click="openJawEditor"><i class="fa fa-wrench"></i> {{ $t('ProjectDetails.editConstruction') }}</button>
                      </div>
                    </div>
                  </div>

                  <project-cart-tab v-else-if="tab.type === 'cart'"
                                    :cart="cart"
                                    :order="order"
                                    :showPrices="!tab.hidePrices && showPricesGlobal && ((!$root.isEmbeddedMode && !isPrintView) || tab.showPricesOnPrint)"
                                    :disableAddress="disableAddress"
                                    :deliveryAddress="deliveryAddress"
                                    :formValues="formValues"
                                    :itemNums="itemNums"
                                    :itemNumsAll="itemNumsAll"
                                    :deliveryOptions="deliveryOptions"
                                    :requireShipping="tab.requireShipping !== false"
                                    :readyToOrder="readyToOrder()"
                                    :loading-price="loadingPrice"
                                    :cartNotice="cartNotice"
                                    v-on:input="handleFormInput"
                                    v-on:change-address="changeAddress"
                                    v-on:order="orderProject"
                                    v-on:item-click="handleCartItemClick"
                                    @change="handleCartItemUpdate"
                  ></project-cart-tab>

                  <div v-else-if="tab.type === 'stl'">
                    <div class="ptop-10 pright-10 pleft-10" v-if="!isPartTabValid()">
                      <div class="alert alert-danger">
                        {{$t('ProjectDetails.missingAttachments')}}
                      </div>
                    </div>
                    <div class="stlfile" v-for="(file, index) in nonConfiguredFiles()">
                      <div class="row">
                        <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                          <a v-on:click="openViewer(file, 'part')">
                            <img :src="previewImage(file)" class="img-responsive" />
                          </a>
                        </div>
                        <div class="col-lg-10 col-md-9 col-sm-9 col-xs-9">
                          <div v-if="file.name">
                            <b>{{ $t('File.name') }}:</b> <span>{{ file.name }}</span>
                          </div>
                          <div>
                            <b>{{ $t('File.hash') }}:</b> <span alt="file.fileHash">{{ file.hash | shorten }}</span>
                          </div>

                          <div class="ptop-10" v-if="!fileHasItems(file)">
                            <div class="label label-warning"><i class="fa fa-exclamation-triangle"></i> {{ $t('ProjectDetails.missingMaterial') }}!</div>
                          </div>

                          <div class="a-r ptop-10"  v-if="!hasOrder">
                            <button v-if="!$root.isEmbeddedMode" type="button" class="btn btn-xs btn-danger" v-on:click="removeStlAttachment(file.hash)"><i class="fa fa-trash"></i> {{ $t('Action.remove') }}</button>
                            <button type="button" class="btn btn-xs btn-primary" v-on:click="editStl(null, file)"><i class="fa fa-pencil"></i> {{ $t('Action.edit') }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="stlfile" v-for="(file, index) in configuredFiles">
                      <div class="row">
                        <div class="col-lg-2 col-md-3 col-sm-3 col-xs-3">
                          <a v-on:click="openViewer(file, 'part')">
                            <img :src="previewImage(file)" class="img-responsive" />
                          </a>
                        </div>
                        <div class="col-lg-10 col-md-9 col-sm-9 col-xs-9">
                          <div v-if="file.name">
                            <b>{{ $t('File.name') }}:</b> <span>{{ file.name }}</span>
                          </div>
                          <div>
                            <b>{{ $t('File.hash') }}:</b> <span alt="file.fileHash">{{ file.fileHash | shorten }}</span>
                          </div>

                          <template v-if="fileHasSelection(file)">
                            <div>
                              <b>{{ $t('ProjectDetails.materialSelection') }}:</b> {{ stlMaterialSelection(file.selection) }}
                            </div>
                          </template>

                          <template v-else>
                            <div class="ptop-10" v-if="!fileHasItems(file)">
                              <div class="label label-warning"><i class="fa fa-exclamation-triangle"></i> {{ $t('ProjectDetails.missingMaterial') }}!</div>
                            </div>
                          </template>

                          <div v-if="fileHasSelection(file) && fileHasDueDate(file)">
                            <b>{{ $t('ProjectDetails.estimatedDelivery') }}:</b>
                            <template v-if="file.duedate">
                              <template v-if="file.duedate.duedate">{{ file.duedate.duedate | formatDate }} ({{ file.duedate.name }})</template>
                              <template v-else-if="file.duedate.text">{{ file.duedate.text }} ({{ file.duedate.name }})</template>
                            </template>
                            <i v-else class="fa fa-circle-notch fa-spin fa-fw"></i>
                          </div>

                          <div v-if="fileHasMissingRequirements(file)" :data-balloon="getMissingRequirementsMsg(file)" data-balloon-pos="right" data-balloon-length="medium" class="label label-warning"><i class="fa fa-exclamation-triangle"></i> {{ $t('ProjectDetails.missingAttachments') }}</div>

                          <div class="a-r ptop-10"  v-if="!hasOrder">
                            <button v-if="!$root.isEmbeddedMode" type="button" class="btn btn-xs btn-danger" v-on:click="removeStl(index)"><i class="fa fa-trash"></i> {{ $t('Action.remove') }}</button>
                            <button type="button" class="btn btn-xs btn-primary" v-on:click="editStl(index)"><i class="fa fa-pencil"></i> {{ $t('Action.edit') }}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ptop-20 a-c" v-if="!hasOrder && !$root.isEmbeddedMode">
                      <button type="button" class="btn btn-lg btn-info" v-on:click="addStl"><i class="fa fa-plus"></i> {{ $t('ProjectDetails.addStl') }}</button>
                      <button v-if="$root.features && $root.features.legacyGoToCart" type="button" class="btn btn-lg btn-success mleft-10" v-on:click="handleChangeTab('cart')"><i class="fa fa-shopping-cart"></i> {{ $t('ProjectDetails.openCart') }}</button>
                    </div>
                  </div>

                  <div v-else-if="tab.type === 'approval'">
                    <div class="ptop-10 pright-10 pleft-10" v-if="approvalNoticeMsg">
                      <div class="alert alert-warning">
                        <i class="fas fa-info-circle"></i> {{ approvalNoticeMsg }}
                      </div>
                    </div>

                    <div class="ptop-10 pright-10 pleft-10" v-if="approvalRelatedProjects && approvalRelatedProjects.length > 1">
                      <h3>Related approvals</h3>
                      <div v-for="related in approvalRelatedProjects">
                        <div v-if="related.ID != projectId">
                          {{ related.name }}, {{ related.lastmodified | formatDate }}
                          <a type="button" class="btn btn-info btn-xs mleft-20" :href="getReferenceUrl(related.ID)" target="_blank">{{ $t('ProjectDetails.openProject') }}</a>
                        </div>
                      </div>
                    </div>

                    <div class="row" v-if="tab.classes" :style="{margin: '0 8px 32px'}" v-for="kind in tab.classes">
                      <div v-for="attachment in fileClasses[kind]" class="attachment-item">
                        <div class="fileicon-cnt">
                            <div class="fileicon-wrapper">
                              <a v-if="!isStl(attachment)"
                                 :href="getDownloadUrl(attachment)"
                                 :style="{display: isImage(attachment) ? '' : 'flex'}"
                                 target="_blank"
                              >
                                <span v-if="!isImage(attachment)"
                                      :style="{background: getIconColor(attachment)}"
                                      class="fileicon fileicon-lg"
                                >{{ attachment.extension }}</span>
                                <img v-if="isImage(attachment)"
                                     :src="getDownloadUrl(attachment)"
                                     class="img-responsive center-block"
                                />
                              </a>
                              <a v-if="isStl(attachment)" :style="{display: 'flex'}">
                                <span v-on:click="openViewer(attachment, 'attachment')"
                                      class="fileicon fileicon-lg"
                                      :style="{background: getIconColor(attachment)}"
                                >{{ attachment.extension }}</span>
                              </a>
                            </div>
                        </div>
                        <div class="attachment-filename" :data-balloon="attachment.filename" data-balloon-pos="right">{{attachment.filename || ' - '}}</div>
                      </div>
                    </div>

                    <project-master-data-tab v-if="tab.form"
                                             :form="tab.form"
                                             :formValues="formValues"
                                             :itemNums="itemNums"
                                             :itemNumsAll="itemNumsAll"
                                             :ext-data="extdata"
                                             :hasOrder="hasOrder"
                                             :isEditable="isEditable"
                                             ref="tab_content"
                                             :force-validation="(badges[`tab_form_${tab.id || index}`] || {}).attempted"
                                             v-on:input="handleFormInput"
                                             v-on:valid="(isValid) => handleFormStatus(`tab_form_${tab.id || index}`, isValid)"
                    >
                    </project-master-data-tab>

                    <alert
                      v-if="isApproved"
                      color="success"
                      :title="$t('ProjectDetails.hasBeenApproved')"
                      icon="check"
                      :text="approvedBy"
                    >
                      <span v-if="approvedBy">{{ approvedBy }}, </span>
                      <span v-if="approvalDate">{{ $t('Common.date') }}: {{ approvalDate | formatDate }}</span>
                    </alert>
                    <alert
                      v-else-if="isRejected"
                      color="danger"
                      :title="$t('ProjectDetails.hasBeenRejected')"
                      icon="times"
                      :text="approvedBy"
                    >
                      <span v-if="approvedBy">{{ approvedBy }}, </span>
                      <span v-if="approvalDate">{{ $t('Common.date') }}: {{ approvalDate | formatDate }}</span>
                    </alert>
                    <template v-else-if="!$root.isEmbeddedMode">
                      <cart
                              v-if="approvalCart && approvalCart.items && approvalCart.items.length"
                              class="card-table"
                              :items="approvalCart.items"
                              :netamount="approvalCart.netamount"
                              :tax="approvalCart.tax"
                              :total="approvalCart.total"
                              :editable="false"
                              :show-prices="showPrices"
                              v-on:itemclick="handleCartItemClick"
                              v-on:change="handleCartItemUpdate"
                      ></cart>

                      <div class="ptop-20">
                        <field
                                label-class="col-md-12 col-sm-12 col-xs-12"
                                field-class="col-md-12 col-sm-12 col-xs-12"
                                name="customerComment"
                                :label="$t('Common.notice')"
                                type="multi"
                                :value="formValues.customerComment"
                                v-on:input="handleFormInput"
                        ></field>
                      </div>
                      <div class="ptop-20 a-c">
                        <button v-for="action in approvalActions"
                                type="button"
                                class="btn btn-lg mright-5 mleft-5"
                                :style="`background-color: ${action.color}`"
                                data-balloon-length="medium"
                                :data-balloon="action.hint ? $t(action.hint) : undefined"
                                v-on:click="handleProjectAction(action)"
                        >
                          <i :class="action.icon"></i> {{ $t(action.label) }}
                        </button>
                        <button v-if="useMessages" type="button" class="btn btn-lg btn-info mleft-15" v-on:click="openMessages"><i class="fas fa-comments"></i> {{ $t('Messages.title') }}</button>
                      </div>
                    </template>
                  </div>

                  <div v-else-if="tab.type !== 'form'">{{JSON.stringify(tab)}}</div>

                  <template v-for="block in getBlocks(tab.outro)">
                    <div v-if="showBlock(block)" :class="block.style" v-html="$t(block, formValues)" ></div>
                  </template>

                  <div class="nav-buttons-container" v-if="!$root.isEmbeddedMode && !isPrintView">
                    <button v-if="index > 0"
                            type="button"
                            class="btn btn-sm btn-default float-left"
                            v-on:click="handleChangeTab(-1)">
                      <i class="fas fa-chevron-left"></i>
                      {{ $t('Action.prev') }}
                    </button>
                    <button v-if="index < tabs.length - 1"
                            type="button"
                            class="btn btn-sm btn-default float-right"
                            v-on:click="handleChangeTab(+1)">
                      {{ $t('Action.next') }}
                      <i class="fas fa-chevron-right"></i>
                    </button>
                    <div style="clear: both"></div>
                  </div>

                </cardtab>
              </card>
            </card>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'

  import ViewAttachments from './Attachments.vue'
  import ViewUploadStl from './UploadStl.vue'
  import ViewJawEditor from './JawEditor.vue'
  import ViewNewOrder from './NewOrder.vue'
  import ViewNewAddon from './NewAddon.vue'
  import ViewProductAddons from './ProductAddons.vue'
  import FileViewer from './FileViewer.vue'
  import TeethList from '../Elements/TeethList.vue'
  import ProjectMasterDataTab from './ProjectMasterDataTab.vue'
  import ProjectToothSelectorTab from './ProjectToothSelectorTab.vue'
  import ProjectToothSelectorPopup from './ProjectToothSelectorPopup.vue'
  import ProjectCartTab from './ProjectCartTab.vue'
  import TabAttachments from './TabAttachments.vue'
  import OrderMessages from './OrderMessages.vue';

  import FormsMixin from '../Mixins/Forms.js'

  import ConfirmPopup from '../Elements/ConfirmPopup.vue';

  var _  = require('underscore'),
    _s = require('underscore.string');

var util = require('../util.js'),
    view = require('../view.js'),
    viewData = {
      renderId: null,
      // Project type properties
      title: '',
      icon: null,
      iconPrefix: null,
      iconColor: null,
      color: null,
      type: null,
      productTree: {},
      modelTree: [],
      orderForm: {},
      intro: null,
      isModified: false, // Check if the project has been modified
      // Requests and alerts
      activeRequest: '',
      loadingPrice: 'ProjectDetails.calculatingPrices',
      alertTitle: '',
      alertText: '',
      alertStyle: '',
      alertIcon: '',
      // View control
      alertCritical: false,
      uploadStl: false,
      editJaw: false,
      // Cart, files, etc.
      hidePrices: false,
      attachments: [],
      fileRequirements: [],
      missingRequirements: [],
      requireAttachments: [],
      requireShipping: true,
      teeth: {
        teeth: [],
        groups: []
      },
      addons: [],
      files: [],
      cart: {},
      cartNotice: null,
      addonNotice: null,
      approvalNotice: null,
      order: {},
      orderDetails: {},
      reference: {},
      defaultItems: false,
      needsAttachments: false,
      deliveryAddress: {},
      deliveryAddressDetails: {},
      deliveryOptions: {},
      deliveryOption: null,
      cartSections: [],
      tabs: [],
      status: 0,
      approvedBy: null,
      approvalDate: null,
      jawImage: null,
      activeTab: 'masterdata',
      formComplete: false,
      formValues: {},
      itemNums: {},
      itemNumsAll: {},
      badges: {},
      dynamicProjectId: null,
      orderCompleteDetails: null,
      approvalActions: [
        {id: 0, label: 'ProjectDetails.reject', icon: 'fas fa-thumbs-down', color: '#E74C3C', requiresComment: true, confirmation: 'ProjectDetails.confirmRejection' },
        {id: 1, label: 'ProjectDetails.approve', icon: 'fas fa-thumbs-up', color: '#5cb85c', confirmation: 'ProjectDetails.confirmApproval' },
      ],
      approvalCart: null,
      approvalRelatedProjects: null,
      cartHash: {},
      cartRequestLatest: null,
      extdata: {},
      fileClasses: {},
      allowUpload: [],
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  mixins: [ FormsMixin ],
  components: {
    Attachments: ViewAttachments,
    UploadStl: ViewUploadStl,
    NewOrder: ViewNewOrder,
    NewAddon: ViewNewAddon,
    JawEditor: ViewJawEditor,
    ProductAddons: ViewProductAddons,
    FileViewer,
    TeethList,
    ProjectMasterDataTab,
    ProjectToothSelectorTab,
    ProjectToothSelectorPopup,
    ProjectCartTab,
    TabAttachments,
    OrderMessages,
    ConfirmPopup
  },
  data() {
    return {
      renderId: Date.now(),
    }
  },
  computed: {
    useMessages() {
      return !this.$root.isTrue('disableMessages');
    },
    image() {
      if (this.files.length > 0) {
        return this.previewImage(this.files[0]);
      }
    },
    isPrintView() {
      return this.$root.isPrintMode;
    },
    isDynamicProject() {
      return /^new:.*/.test(this.$parent.viewIndex);
    },
    dynamicProjectType() {
      return this.$parent.viewIndex.substring(4);
    },
    projectId() {
      return this.isDynamicProject ? this.dynamicProjectId : this.$parent.viewIndex;
    },
    hasItems() {
      return typeof this.cart.items == 'object' && this.cart.items != null && this.cart.items.length > 0;
    },
    hasFiles() {
      return this.files.length > 0;
    },
    hasTeeth() {
      return this.teeth.hasOwnProperty('teeth') && this.teeth.teeth.length > 0;
    },
    hasIntro() {
      return this.intro != null;
    },
    hasAttachments() {
      return this.attachments.length > 0;
    },
    hasShippingAddress() {
      return typeof this.formValues.shipping == 'string' && this.formValues.shipping != '';
    },
    hasOrder() {
      console.log('this.reference', this.order);
      return typeof this.order.ID != 'undefined';
    },
    hasReference() {
      console.log('this.reference', this.reference);
      return typeof this.reference.ID != 'undefined';
    },
    isEditable() {
      return (this.status === 0 || this.status === 3) && !this.$root.isPrintMode;
    },
    isApproved() {
      return this.status === 4;
    },
    isRejected() {
      return this.status === 5;
    },
    fileCartColSpan() {
      return typeof this.order.ID == 'undefined' ? 'col-lg-7 col-md-6' : 'col-lg-12 col-md-12';
    },
    projectUrl() {
      return this.$root.url + 'project/' + this.projectId;
    },
    fileCount() {
      return this.files.length;
    },
    badgeFileColor() {
      return this.files.length > 0 ? 'success' : 'warning';
    },
    badgeMasterdata() {
      return this.formComplete ? null : '!';
    },
    badgeConstruction() {
      return this.hasTeeth ? null : '!';
    },
    badgeAttachment() {
      return this.needsAttachments ? '!' : null;
    },
    badgeCartColor() {
      return this.readyToOrder() ? 'success' : 'warning';
    },
    addonNoticeMsg() {
      return (typeof this.addonNotice != 'undefined') ? this.$root.getLabelText(this.addonNotice) : null;
    },
    approvalNoticeMsg() {
      return (typeof this.approvalNotice != 'undefined') ? this.$root.getLabelText(this.approvalNotice) : null;
    },
    showPrices() {
      return this.hidePrices ? !this.hidePrices : this.showPricesGlobal;
    },
    showPricesGlobal() {
      return typeof this.$parent.currentUser.hidePrices == null ? true : !this.$parent.currentUser.hidePrices;
    },
    disableAddress() {
      return this.$root.hasOwnProperty('disableAddressSelect') && (typeof this.$root.disableAddressSelect != 'undefined') && this.$root.disableAddressSelect;
    },
    tabApproval() {
      return this.tabs.some(x => x.type === 'approval');
    },
    tabStl() {
      return this.tabs.some(x => x.type === 'stl');
    },
    customerBillingInfoVisibility() {
      return (this.$root.isEmbeddedMode || this.isPrintView) && this.hasOrder && this.workflowType.customerBillingInfoVisibility;
    },
    customerShippingInfoVisibility() {
      return (this.$root.isEmbeddedMode || this.isPrintView) && this.hasOrder && this.workflowType.customerShippingInfoVisibility;
    },
    customerInfoVisibility() {
      return this.customerBillingInfoVisibility || this.customerShippingInfoVisibility;
    },
    form() {
      var form = {
        name: {
          label: this.$t('Common.name'),
          type: 'text'
        },
        description: {
          label: this.$t('Common.notice'),
          type: 'multi'
        }
      };

      for (let i in this.orderForm) {
        if (this.orderForm.hasOwnProperty(i) && !form.hasOwnProperty(i)) {
            form[i] = this.orderForm[i];
        }
      }

      return form;
    },
    restrictEditParts() {

    },
    restrictEditAttachments() {

    },
    restrictEditAddress() {

    },
    orderDialogForm() {
      const {orderDialog} = this.tabs.find(({type}) => type === 'cart') || {};
      return orderDialog ;
    },
    workflowType() {
      const type = this.type;
      let projectType = {};
      if (typeof this.$root.workflowTypes[type] === 'object') {
        projectType = this.$root.workflowTypes[type]
      } else {
        for (var id in this.$root.workflowTypes) {
          if (this.$root.workflowTypes.hasOwnProperty(id)
            && typeof this.$root.workflowTypes[id].alias === 'object'
            && this.$root.workflowTypes[id].alias.indexOf(type) !== false) {
            projectType = this.$root.workflowTypes[id];
            break;
          }
        }
      }

      projectType.ID = type;

      return projectType;
    },
    configuredFiles() {
      if (Array.isArray(this.files) && this.fileClasses && Array.isArray(this.fileClasses.part)) {
        return this.files.map(_ => {
          return {
            ..._,
            ...this.fileClasses.part.find(p => _.fileHash === p.hash)
          }
        })
        // const knownHashes = this.files.map(x => x.fileHash);
        // return this.fileClasses.part.filter(x => knownHashes.indexOf(x.hash) < 0);
      }
      return this.files;
    },
  },
  mounted() {
    if (!this.projectId && !this.isDynamicProject) {
      this.$parent.openView('Projects');
      this.$parent.alertDanger(this.$t('ProjectDetails.errorNoProjectnum'));
    }

    this.$parent.viewTitle = this.$t('ProjectDetails.title');
    this.$parent.setPrevious('Projects');

    this.badges = {};
    this.tabs.forEach(({id}, index) => {
      this.badges[`tab_${id || index}`] = {
        value: undefined,
        valid: undefined,
        color: undefined,
      }
    })

    let deliveryAddressId = typeof this.$parent.viewOptions === 'object' && typeof this.$parent.viewOptions.deliveryAddress === 'object'
      ? this.$parent.viewOptions.deliveryAddress.ID
      : null;

    this.reset(deliveryAddressId, () => {
      // Load the address as viewParam
      if (typeof this.$parent.viewParam === 'string') {
        this.handleChangeTab(this.$parent.viewParam);
        if (typeof this.$parent.viewOptions === 'object' && typeof this.$parent.viewOptions.deliveryAddress === 'object') {
          this.deliveryAddress = this.$parent.viewOptions.deliveryAddress;
          this.isModified = true;
        }
      } else {
        this.handleChangeTab(null);
      }

      setTimeout(() => this.handleChangeTab(this.activeTab), 500);
    });
  },
  methods: {
    nonConfiguredFiles() {
      if (Array.isArray(this.files) && this.fileClasses && Array.isArray(this.fileClasses.part)) {
        const knownHashes = this.files.map(x => x.fileHash);
        return this.fileClasses.part.filter(x => knownHashes.indexOf(x.hash) < 0);
      }
      return [];
    },
    showBlock(cfg) {
      return cfg && this.meetsRequirements({requires: cfg.showIf});
    },
    getBlocks(blockOrArray) {
      return !blockOrArray ? [] : Array.isArray(blockOrArray) ? blockOrArray : [blockOrArray]
    },
    openMessages() {
      this.$refs.messages.openDialog();
    },
    getTabCustomError(id) {
      const tab_custom_badge = this.badges[`tab_custom_${id}`] || {};

      if (tab_custom_badge.valid === false && tab_custom_badge.message) {
        return tab_custom_badge.message
      }

      return null;
    },
    getBadge(id) {
      const tab_badge = this.badges[`tab_${id}`] || {};
      const tab_form_badge = this.badges[`tab_form_${id}`] || {};
      const tab_custom_badge = this.badges[`tab_custom_${id}`] || {};

      if (tab_custom_badge.valid === false && tab_custom_badge.value) {
        return tab_custom_badge.value
      }

      if (tab_form_badge.valid === false && tab_form_badge.value) {
        return tab_form_badge.value
      }

      if (tab_badge.valid !== undefined && tab_badge.value) {
        return tab_badge.value
      }

      if (tab_form_badge.valid === true && tab_form_badge.value) {
        return tab_form_badge.value
      }

      return null;
    },

    getBadgeColor(id) {
      const tab_badge = this.badges[`tab_${id}`] || {};
      const tab_form_badge = this.badges[`tab_form_${id}`] || {};
      const tab_custom_badge = this.badges[`tab_custom_${id}`] || {};

      if (tab_custom_badge.valid === false && tab_custom_badge.color) {
        return tab_custom_badge.color
      }

      if (tab_form_badge.valid === false && tab_form_badge.color) {
        return tab_form_badge.color
      }

      if (tab_badge.valid !== undefined && tab_badge.color) {
        return tab_badge.color
      }

      if (tab_form_badge.valid === true && tab_form_badge.color) {
        return tab_form_badge.color
      }

      return '';
    },

    isAvailable(tab) {
      if (tab.hideOrdered && this.hasOrder) {
        return false;
      }

      if (tab.secure === true && this.$root.isEmbeddedMode) {
        return false;
      }

      return tab.type !== 'addons' || !this.hasOrder;
    },

    readyToOrder() {
      return (this.tabConstruction ? this.hasTeeth : true)
        && this.hasItems
        && !this.needsAttachments
        && this.formComplete
        && Object.keys(this.badges).every(tab => this.badges[tab].valid !== false);
    },
    cartItemCount() {
      if (typeof viewData.cart.items != 'object') {
        return null;
      }
      var c = 0;
      viewData.cart.items.forEach(function(item) {
        if (item != null && item.type == 0) {
          c++;
        }
      });

      return c;
    },
    async reset(deliveryAddressId, callback) {
      this.renderId = Date.now();

      for (var i in resetData) {
        if (resetData.hasOwnProperty(i)) {
          if (typeof resetData[i] != 'object') {
            viewData[i] = resetData[i];
          }
        }
      }

      viewData.jawImage = null;
      viewData.teeth = {
        teeth: [],
        groups: []
      };
      viewData.intro = null;
      viewData.addons = [];
      viewData.attachments = [];
      viewData.files = [];
      viewData.cart = {};
      viewData.cartNotice = null;
      viewData.addonNotice = null;
      viewData.reference = {};
      viewData.cartSections = [];
      viewData.order = {};
      viewData.formValues = {};
      viewData.itemNums = {};
      viewData.deliveryAddress = {};
      viewData.deliveryOptions = {};
      viewData.missingRequirements = [];
      viewData.requireAttachments = [];
      viewData.deliveryOption = null;
      viewData.approvedBy = null;
      viewData.approvalDate = null;
      viewData.tabs = [];
      viewData.loadingPrice = '';

      this.fileClasses = {};

      this.closeAlert();

      if (typeof this.$refs.attachments != 'undefined') {
        this.$refs.attachments.reset();
      }

      if (!this.isDynamicProject) {
        this.loadProject(deliveryAddressId, callback);
      } else {
        this.setProjectType(this.dynamicProjectType);
        this.formComplete = this.getFormStatus();

        const {data} = await this.$http.get(this.$root.url + 'address/', {params: viewData.filters});

        const addresses = data.result.data;

        this.deliveryAddress = addresses.find(x => x.isShipping === 2) || addresses.find(x => x.isHome === 1) || undefined;

        await new Promise(resolve => this.updatePrices(resolve));

        this.handleChangeTab(this.$parent.viewParam);

        if (typeof this.$parent.viewOptions == 'object' && typeof this.$parent.viewOptions.deliveryAddress == 'object') {
          this.deliveryAddress = this.$parent.viewOptions.deliveryAddress;
        }
        this.isModified = true;
      }
    },
    async loadProject(deliveryAddressId, callback) {
      // Get the project details
      this.activeRequest = this.$t('ProjectDetails.loading');

      let url = this.projectUrl + (typeof deliveryAddressId != 'undefined' && deliveryAddressId != null ? '?deliveryAddressId=' + deliveryAddressId : '');
      try {
        const res = await this.$http.get(url);
        this.activeRequest = '';
        if (typeof res.data.result != 'object') {
          this.alertTitle = this.$t('ProjectDetails.errorCouldNotLoad');
          this.alertText  = this.$t('ProjectDetails.errorInvalidServerResponse');
          this.alertCritical = true;
          return;
        }

        this.setProjectType(res.data.result.type == 'undefined' ? 'stl' : res.data.result.type);
        viewData.status = res.data.result.status;
        viewData.approvedBy = res.data.result.approvedBy;
        viewData.approvalDate = res.data.result.approvalDate;
        viewData.extdata = res.data.result.extdata;
        viewData.allowUpload = res.data.result.allowUpload || [];

        this.approvalActions = res.data.result.actions || viewData.approvalActions;
        this.approvalCart = res.data.result.cart;
        if (typeof res.data.result.data == 'object' && res.data.result.data != null) {
          if (typeof res.data.result.data.form == 'object') {
            this.formValues = res.data.result.data.form || {};
            this.itemNums = JSON.parse(this.formValues.__itemNums || '{}');
          }
          var keys = ['files', 'teeth', 'addons'];
          keys.forEach(function(key) {
            if (res.data.result.data.hasOwnProperty(key)) {
              this[key] = res.data.result.data[key];
            }
          }.bind(this));
        }

        if (typeof this.teeth.teeth == 'undefined') {
          this.teeth = {
            teeth: [],
            groups: []
          };
        }

        // Initialize remaining form values (name and description)
        for (var key in this.form) {
          if (this.form.hasOwnProperty(key)) {
            if (typeof res.data.result[key] != 'undefined') {
              this.formValues[key] = res.data.result[key];
            }
          }
        }

        (this.$refs.forms || []).forEach(x => x.refresh());

        this.formComplete = this.getFormStatus();

        if (typeof res.data.result.img != 'undefined' && res.data.result.img != null) {
          this.jawImage = res.data.result.img;
        }

        this.orderDetails = {};
        if (typeof res.data.result.transaction == 'object' && typeof res.data.result.transaction.ID != 'undefined') {
          viewData.order = res.data.result.transaction;

          let url = this.$root.url + 'order/' + res.data.result.transaction.ID;
          this.$http.get(url).then(res => {
            if (!res.data || typeof res.data.result != 'object') {
              return;
            }
            this.orderDetails = res.data.result;
            this.$forceUpdate()
          })
        }

        if (typeof res.data.result.reference == 'object' && typeof res.data.result.reference.ID != 'undefined') {
          viewData.reference = res.data.result.reference;
        }

        if (typeof res.data.result.deliveryAddress == 'object') {
          this.deliveryAddress = res.data.result.deliveryAddress;
          this.deliveryAddressDetails = res.data.result.deliveryAddress;
          if (res.data.result.transaction && res.data.result.transaction.deliveryAddress) {
            this.deliveryAddressDetails = res.data.result.transaction.deliveryAddress;
          }
        }

        if (typeof res.data.result.deliveryOptions == 'object') {
          this.deliveryOptions = res.data.result.deliveryOptions;
        }

        if (typeof res.data.result.cart == 'object') {
          this.cart = res.data.result.cart;
        }

        if (typeof callback == 'function') {
          callback.call(this);
        }

        this.$root.sentry(function(Raven) {
          Raven.captureBreadcrumb({
            message: 'ProjectDetails.loadProject',
            data: res
          });
        }.bind(this));

        // @EXPERIMENTAL
        if (!this.tabApproval) {
          if (!this.hasOrder) {
            await new Promise(r => setTimeout(r, 100));
          }

          this.updatePrices(null, function() {
            this.collectFileRequirements();
            this.updateRequirements();
          }.bind(this));
        } else {
          const classes = this.tabs.filter(x => x.type === 'approval').reduce((p, {classes}) => [...p, ...classes], []);
          classes.forEach(kind => {
            let url = this.projectUrl + `/${kind}`;
            this.$http
              .get(url)
              .then(res => {
                this.fileClasses[kind] = res.data.result;
                this.$forceUpdate();
              });
          });

          if (this.workflowType.enableRelatedProjects === true && this.reference && this.reference.ID) {
            const {body} = await this.$http.get(`${this.$root.url}project/?referenceid=${this.reference.ID}&status=3`);
            const {data} = body.result;
            this.approvalRelatedProjects = data;
          }
        }

        if (this.tabStl) {
          if (this.$root.isPrintMode) {
            try {
              const partRes = await this.$http.get(this.projectUrl + `/part`);
              this.files = this.files.slice();
              this.fileClasses.part = partRes.data.result;
              this.updatePartTabValidation();
              this.$forceUpdate();
            } catch {}
          } else {
            this.$http
              .get(this.projectUrl + `/part`)
              .then(res => {
                this.files = this.files.slice();
                this.fileClasses.part = res.data.result;
                this.updatePartTabValidation();
                this.$forceUpdate();
              });
          }

        }
      } catch (res) {
        if (typeof res.code != 'undefined' && res.code === 401) {
          return;
        }

        this.activeRequest = '';
        this.alertTitle = this.$t('ProjectDetails.errorCouldNotLoad');
        this.alertCritical = true;
        if (res.data && typeof res.data.error != 'undefined') {
          this.alertText = res.data.error;
        }

        // Sentry
        this.$root.sentry((Raven) => {
          Raven.setExtraContext(res);
          Raven.captureMessage('Could not load project: ' + this.alertText, {
            level: 'error'
          });
        });
      }
    },
    async saveProject(callback, approved, silent) {

      if (this.isDynamicProject && !viewData.dynamicProjectId) {
        const {data} = await this.$http.post(this.$root.url + 'project/', {
          type: this.dynamicProjectType,
          name: this.$t(this.workflowType.defaultName || Date.now().toString(36)),
        });

        viewData.dynamicProjectId = data.result;
      }

      var data = {
        form   : Object.assign({}, JSON.parse(JSON.stringify(this.formValues)), {'__itemNums': JSON.stringify(this.itemNums)}),
        files  : JSON.parse(JSON.stringify(this.files)),
        teeth  : JSON.parse(JSON.stringify(this.teeth)),
        addons : JSON.parse(JSON.stringify(this.addons)),
        attachments : JSON.parse(JSON.stringify(this.attachments)),
        img    : JSON.parse(JSON.stringify(this.jawImage)),
        deliveryAddress: this.deliveryAddress.ID
      };
      data.name = data.form.name;
      delete data.form.name;
      data.description = data.form.description;
      delete data.form.description;

      // Add project approval
      if (typeof approved !== 'undefined') {
        data.approved = approved;
      }

      if (!silent) {
        this.activeRequest = this.$t('ProjectDetails.saving');
      }
      this.$http.put(this.projectUrl, data).then(
        function(res) {
          this.activeRequest = '';
          if (typeof callback == 'function') {
            callback.call(this);
          } else if (!silent) {
            this.$parent.alertSuccess(this.$t('ProjectDetails.saved'));
          }
          this.isModified = false;
          this.$root.sentry(function(Raven) {
            Raven.captureBreadcrumb({
              message: 'ProjectDetails.saveProject',
              data: data
            });
          }.bind(this));
        }.bind(this),
        function(res) {
          this.activeRequest = '';
          this.alertTitle = this.$t('ProjectDetails.errorCouldNotSave');
          if (typeof res.data.error != 'undefined') {
            this.alertText = res.data.error;
          }

          // Sentry
          this.$root.sentry(function(Raven) {
            Raven.setExtraContext(res);
            Raven.captureMessage('Could not save project: ' + this.alertText, {
              level: 'error'
            });
          }.bind(this));
        }.bind(this));
    },
    confirmProjectRemove(callback) {
      if (this.$refs.deletePopup) {
        this.$refs.deletePopup.openDialog();
      } else {
        this.removeProject(callback);
      }
    },
    removeProject(callback) {
      this.activeRequest = this.$t('ProjectDetails.removing');
      this.$http.delete(this.projectUrl).then(
        function(res) {
          this.activeRequest = '';
          const back = window.location.hash || '';
          this.$parent.resolveRoute(back.length > 1 ? back : 'Projects');
          this.$parent.alertRemoved( this.$t('ProjectDetails.removed') );
          if (typeof callback == 'function') {
            callback.call(this);
          }
        }.bind(this),
        function(res) {
          this.activeRequest = '';
          this.alertTitle = this.$t('ProjectDetails.errorCouldNotRemove');
          if (typeof res.data.error != 'undefined') {
            this.alertText = res.data.error;
          }

          // Sentry
          this.$root.sentry(function(Raven) {
            Raven.setExtraContext(res);
            Raven.captureMessage('Could not remove project: ' + this.alertText, {
              level: 'error'
            });
          }.bind(this));
        }.bind(this));
    },
    async orderProject() {
      if (this.isDynamicProject) {
        const {data} = await this.$http.post(this.$root.url + 'project/', {
          type: this.dynamicProjectType,
          name: this.$t(this.workflowType.defaultName || Date.now().toString(36)),
        });

        viewData.dynamicProjectId = data.result;
      }

      await new Promise(resolve => this.saveProject(resolve));

      // picker.openDialog(m, d, e, h)
      const model = {
        layer: null,
        range: [],
        selection: {},
        values: {
          description: this.formValues.description,
        },
        itemnums: {},
      };

      const formData = this.orderDialogForm;
      const form = formData ? await new Promise(resolve => this.$refs.picker.openDialog(formData, model, {
          title: 'OrderDetails.placeOrder',
          action: 'Action.confirmPayment',
          icon: 'truck'
        },
        (state, l, r, values) => state === 'save' ? resolve(values) : null)) : {};

      // this.activeRequest = true;
      const {data} = await this.$http.post(this.$root.url + 'order/', {
        projectId: this.projectId,
        form,
        items: this.cartSections,
        image: this.image
      });


      viewData.dynamicProjectId = null;

      // this.activeRequest = false;
      // this.$emit('ordercreated', res.data.result);
      this.openOrder(data.result);

      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'place_order', {
          'event_label': res.data.result.ordernum
        });
      }

      this.$refs.picker.closeDialog();
    },
    openOrder(order) {
      if (typeof order == 'object') {
        if (order.message || order.icon) {
          this.orderCompleteDetails = order;
          return;
        }

        this.$parent.openView('OrderDetails', order.ID);
        this.$parent.alertSuccess( this.$t('ProjectDetails.orderSuccessful', {order: order.ordernum}) );
      } else {
        this.$parent.openView('OrderDetails', order);
      }
    },
    getReferenceUrl(referenceId) {
      return this.$parent.getUrl('ProjectDetails', referenceId);
    },
    eachPart(callback) {
      var cartObjects = {
            file: this.files,
            teeth: this.teeth.groups
          };

      Object.keys(cartObjects).forEach(function(type) {
        var cartObject = cartObjects[type];
        cartObject.forEach(function(obj, index) {
          callback(obj, type, index)
        });
      }.bind(this));
    },
    async updatePrices(callbackCart, callbackDueDate) {
      if (this.hasOrder) {
        if (this.cart.items) {
          callbackCart?.call(this);
          return;
        }
        const {data: {result = {}}} = await this.$http.get(this.$root.url + 'transaction/' + this.order.ID, {
          locale: this.$i18n.locale,
        });
        const {cart = {}} = result;
        this.cart = cart;
        this.itemCount = Array.isArray(cart.items) ? cart.items.length : null;
        callbackCart?.call(this);
        this.$forceUpdate();
        return ;
      }

      this.loadingPrice = 'ProjectDetails.calculatingPrices';

      const sections = [];

      const addItem = function(items, itemnum, amount) {
        itemnum.split(',').forEach(itemnum => {
          items[itemnum] = (items[itemnum] || 0) + amount;
        });
      };

      // Add the default items
      if (true) {
        const section = {
          title: this.$t('ProjectDetails.costs'),
          id: 'project',
          items: {}
        };

        if (this.defaultItems && typeof this.defaultItems === 'object') {
          Object.keys(this.defaultItems).forEach(function (itemnum) {
            addItem(section.items, itemnum, this.defaultItems[itemnum]);
          }.bind(this));
        }

        const items = (this.$refs.tab_content || [])
          .filter(x => x.getItemNums)
          .map(x => x.getItemNums());

        []
          .concat(...items)
          .filter(({section}) => section === null)
          .forEach(({items}) => {
            Object.keys(items).forEach(itemnum => {
              addItem(section.items, itemnum, items[itemnum]);
            })
          });

        if (Object.keys(section.items).length > 0) {
          sections.push(section);
        }
      }

      this.eachPart((obj, type, index) => {
        const section = {
          title: type == 'file' ? obj.name : obj.itemName + ' ' + obj.rangeLabel,
          id: type,
          formValues: obj.formValues,
          items: {}
        };

        if (type === 'file') {
          section.fileHash = obj.fileHash;
          section.imageUrl = obj.imageUrl;
          section.selection = JSON.parse(JSON.stringify(obj.selection));
        }

        obj.itemnums && Object
          .entries(obj.itemnums || {})
          .forEach(([itemnum, amount]) => {
            addItem(section.items, itemnum, parseInt(amount));
          });

        if (Object.keys(section.items).length > 0) {
          sections.push(section);
        }
      });

      const items = (this.$refs.tab_content || [])
        .filter(x => x.getItemNums)
        .map(x => x.getItemNums());

      []
        .concat(...items)
        .filter(({section}) => section !== null)
        .forEach(({section: _, items}) => {
          var section = {
            title: _.title,
            id: _.id,
            formValues: {},
            items: {}
          };

          Object
            .entries(items)
            .forEach(([itemnum, amount]) => {
              addItem(section.items, itemnum, parseInt(amount));
            });

          if (Object.keys(section.items).length > 0) {
            sections.push(section);
          }
        });


      // Create the addons
      if (this.addons.length > 0) {
        (function() {
          var section = {
            title: this.$t('ProjectDetails.addons'),
            id: 'addons',
            items: {}
          };

          this.addons.forEach((addon) => addItem(section.items, addon.itemnum, addon.amount));

          if (Object.keys(section.items).length > 0) {
            sections.push(section);
          }
        }.bind(this))()
      }

      // Get additional items from order form values
      if (true) {
        (function() {
          var section = {
            title: this.$t('ProjectDetails.orderOptions'),
            id: 'options',
            items: {}
          };

          // Add additional items from the order form
          Object.keys(this.orderForm).forEach(function(key) {
            if (typeof this.formValues[key] !== 'undefined' && this.formValues[key] != null) {
              const itemnum = this.getFieldItem(this.orderForm[key], this.formValues[key]);
              if (itemnum !== false) {
                addItem(section.items, itemnum, 1);
              }
            }
          }.bind(this));

          // Add the shipping item
          if (typeof viewData.formValues.shipping === 'string' && viewData.formValues.shipping !== '') {
            addItem(section.items, viewData.formValues.shipping, 1);
          }

          if (Object.keys(section.items).length > 0) {
            sections.push(section);
          }
        }.bind(this))()
      }

      const form = JSON.parse(JSON.stringify(this.formValues));

      this.itemNumsAll = Object.assign({}, this.itemNums);
      sections.forEach(({items}) => {
        items && Object.entries(items).forEach(([itemnum, qty]) => {
          this.itemNumsAll[itemnum] = (this.itemNumsAll[itemnum] || 0) + qty;
        })
      });

      this.$forceUpdate();

      viewData.cartSections = sections;
      viewData.loadingPrice = 'ProjectDetails.calculatingPrices';

      delete form.__itemNums;

      const data = {
        items: sections,
        withDueDate: true,
        locale: this.$i18n.locale,
        form,
        workflow: this.type,
        projectId: this.projectId,
      };

      if (!this.hasOrder) {
        this.updateFileDueDate(callbackDueDate);
      }

      let result = {};
      const cacheKey = JSON.stringify(data);
      const cache = this.cartHash[cacheKey];
      if (cache && (typeof cache === 'object')) {
        result = cache.result;
      } else if (cache !== undefined) {
        // do nothing;
        return
      } else if (this.cartRequestLatest !== cacheKey) {
        this.cartRequestLatest = cacheKey;
        this.cartHash[cacheKey] = null;
        try {
          const res = await this.$http.post(this.$root.url + 'cart/', data);
          this.cartHash[cacheKey] = res.data;
          result = res.data.result
        } catch (e) {
          console.error('calculation failed', e);
          this.cartHash[cacheKey] = undefined;
          result = {error: 'ProjectDetails.calculatingPricesFailed'};
        }
        if (this.cartRequestLatest !== cacheKey) {
          return
        }
        this.cartRequestLatest = null;
      }

      viewData.cartNotice = result.notice || undefined;
      viewData.cart = result;
      viewData.itemCount = typeof (result.items) == 'undefined' ? null : result.items.length;
      if (typeof callbackCart == 'function') {
        callbackCart.call(this);
      }

      this.handleTabStatus('tab_cart', this.readyToOrder());

      viewData.loadingPrice = '';
      this.$forceUpdate();

    },
    // Get the item number from a form field
    getFieldItem(field, fieldValue) {
      switch (this.fieldType(field)) {
        case 'hidden':
        case 'checkbox':
          if (typeof field.itemnum != 'undefined') {
            if (typeof fieldValue == 'undefined') {
              return true;
            }

            return fieldValue ? field.itemnum : false;
          }
          break;
        case 'select':
          for (let i in field.options) {
            if (field.options.hasOwnProperty(i)) {
              if (typeof field.options[i] == 'object' && typeof field.options[i].value != 'undefined' && typeof field.options[i].itemnum != 'undefined') {
                if (typeof fieldValue == 'undefined') {
                  return field.options[i].itemnum;
                }
                if (field.options[i].value == fieldValue) {
                  return field.options[i].itemnum;
                }
              }
            }
          }
          break;
      }

      return false;
    },
    updateFileDueDate(callbackDueDate) {
      var files = JSON.parse(JSON.stringify(this.files));
      this.$http.post(this.$root.url + 'cart/duedate', {
        files: files
      }).then(function(res) {
        if (typeof res.data.result != 'object') {
          this.alertTitle = this.$t('ProjectDetails.errorCouldNotCalcDuedate');
          this.alertText  = this.$t('ProjectDetails.errorInvalidServerResponse');
          this.alertCritical = true;
          return;
        }

        for (var i = 0 ; i < files.length ; i++) {
          if (typeof res.data.result[files[i].fileHash] == 'object') {
            files[i].duedate = res.data.result[files[i].fileHash];
          } else {
            files[i].duedate = {};
          }
        }

        this.files = files;

        if (typeof callbackDueDate == 'function') {
          callbackDueDate.call(this);
        }
      }.bind(this));
    },
    fileHasDueDate(file) {
      if (typeof file.duedate == 'undefined') {
        return typeof this.order.ID == 'undefined';
      }

      return typeof file.duedate == 'object' && typeof file.duedate.duedate != 'undefined';
    },
    fileHasSelection(file) {
      return Array.isArray(file.selection) && file.selection.length > 0;
    },
    fileHasItems(file) {
      return (typeof file.itemnums == 'object') && Object.keys(file.itemnums).length > 0;
    },
    fileHasMissingRequirements(file) {
      if (typeof file == 'undefined')
        file = this;

      return typeof file.missingRequirements === 'object' && file.missingRequirements instanceof Array && file.missingRequirements.length > 0;
    },
    getMissingRequirementsMsg(file) {
      if (typeof file == 'undefined')
        file = this;

      if (this.fileHasMissingRequirements(file)) {
        for (var i = 0 ; i < file.missingRequirements.length ; i++) {
          if ((typeof file.missingRequirements[i] === 'object') && (typeof file.missingRequirements[i].message === 'string')) {
            return file.missingRequirements[i].message;
          }
        }
      }

      return false;
    },
    getAllMissingRequirementsMsgs() {
      const values = Object.values(this.files).map(this.getMissingRequirementsMsg).filter(x => x);
      const set = new Set(values);
      return [...set.values()];
    },
    updateConstructionTabValidation() {
      this.workflowType.tabs.filter(({type}) => type === 'construction').forEach(({id}, index) => {
        const tab = `tab_${id || index}`;
        this.badges[tab] = {
          valid: true,
          value: this.badgeConstruction,
          color: 'success',
        }
      });
    },
    isPartTabValid() {
      const {requires = 0} = this.workflowType.tabs.find(({type}) => type === 'stl') || {};
      return this.files.length >= requires;
    },
    updatePartTabValidation() {
      const isValid = this.nonConfiguredFiles().length < 1 && this.isPartTabValid();

      const isRequirementsMet = !Object.values(this.files).some(this.fileHasMissingRequirements);

      this.workflowType.tabs.filter(({type}) => type === 'stl').forEach(({id}, index) => {
        const tab = `tab_${id || index}`;
        this.badges[tab] = {
          valid: isValid,
          value: (this.fileCount + this.nonConfiguredFiles().length) || '!',
          color: !isValid ? 'danger' : !isRequirementsMet ? 'warning' : 'success',
        }
      });
    },
    addStl() {
      this.openUploader();
    },
    async removeStlAttachment(hash) {
      const url = this.uploadUrl('part') + '/' + hash;
      await this.$http.delete(url);
      const {data} = await this.$http.get(this.projectUrl + `/part`);
      this.fileClasses.part = data.result;
      this.updatePartTabValidation();
      this.$forceUpdate();
    },
    async removeStl(index) {
      const removed = this.files[index];
      try {
        await this.removeStlAttachment(removed.fileHash);
      } catch (e) {
        console.warn('Remove part attachment error', e);
      }
      this.files.splice(index, 1);
      this.updatePrices();
      this.isModified = true;
      this.updatePartTabValidation()
    },
    editStl(index, file) {
      // Pass as clone
      this.openUploader();
      const data = this.files[index] || {
        name: file.filename,
        fileType: file.extension,
        fileHash: file.hash,
        itemnums: [],
        imageUrl: this.previewImage(file),
        missingRequirements: [],
        requireAttachments: {},
        formValues: {},
        selection: [],
        images: file.meta ? file.meta.images : [],
        selectedItem: {}
      };

      if (Array.isArray(this.fileClasses.part)) {
        const f = this.fileClasses.part.find(x => x.hash === data.fileHash);
        data.token = f ? f.token : undefined;
      }

      this.$refs.uploader.load(JSON.parse(JSON.stringify(data)), true);
      this.$refs.uploader.setPickingMode(true);
    },
    appendFiles(fileList) {
      for (var i = 0 ; i < fileList.length ; i++) {
        this.appendFile(fileList[i], true);
      }

      // Update the attachment requirements after prices and delivery times are updated
      this.updatePrices(null, function() {
        this.collectFileRequirements();
        this.updateRequirements();
      }.bind(this));

      this.isModified = true;
      this.updatePartTabValidation()
    },
    appendFile(file, noUpdatePrices) {
      this.uploadStl = false;
      for (var i = 0 ; i < this.files.length ; i++) {
        if (this.files[i].fileHash == file.fileHash) {
          this.files[i] = file;
          if (typeof noUpdatePrices == 'undefined') {
            this.updatePrices();
          }
          return;
        }
      }

      this.files.push(file);

      if (typeof noUpdatePrices == 'undefined') {
        this.updatePrices();
        this.isModified = true;
      }

      this.$root.sentry(function(Raven) {
        Raven.captureBreadcrumb({
          message: 'ProjectDetails.appendFile',
          category: 'edit',
          data: file
        });
      }.bind(this));
    },
    updateRequirements() {
      let reqCount = 0;

      const updateMissingRequirements = (obj) => {
        obj.missingRequirements = [];
        if (typeof obj.requireAttachments === 'object' && obj.requireAttachments instanceof Array) {
          obj.requireAttachments.forEach((requirement) => {
            if (this.checkRequirement(requirement) !== true) {
              obj.missingRequirements.push(requirement);
              reqCount++;
            }
          });
        }
      };

      this.eachPart(updateMissingRequirements);

      // Check if the project itself has a requirement
      updateMissingRequirements(this);

      this.needsAttachments = reqCount > 0;
    },
    collectFileRequirements() {
      let requirements = [];

      const updateMissingRequirements = ({requireAttachments}) => {
        if (Array.isArray(requireAttachments)) {
          requirements = requirements.concat(...requireAttachments);
        }
      };

      (this.$refs.tab_content || []).forEach(x => updateMissingRequirements(x))

      this.tabs.forEach(x => updateMissingRequirements(x));

      updateMissingRequirements(this);

      this.fileRequirements = requirements.filter(x => x.requires);
    },
    checkRequirement(requirement) {
      if (typeof requirement === 'string') {
        if (requirement.match(/^\/.*\/$/)) {
          // Case 1: Check for regular expression
          try {
            var rx = new RegExp(requirement.replace(new RegExp('^/|/$', 'g'), ''));
            for (var i = 0 ; i < this.attachments.length ; i++) {
              if (this.attachments[i].filename.match(rx)) {
                return true;
              }
            }
          } catch (e) {}
        } else {
          // Case 2: Check for file extension
          for (var i = 0 ; i < this.attachments.length ; i++) {
            if (this.attachments[i].extension.toLowerCase() === requirement.toLowerCase()) {
              return true;
            }
          }
        }

        return false;
      }

      // Case 3: Composite rule
      if (typeof requirement === 'object') {
        if (requirement.hasOwnProperty('OR')) {
          for (var i = 0 ; i < requirement.OR.length ; i++) {
            if (this.checkRequirement(requirement.OR[i])) {
              return true;
            }
          }
          return false;
        } else if (requirement.hasOwnProperty('AND')) {
          requirement = requirement.AND;
        }

        if (requirement instanceof Array) {
          for (var i = 0 ; i < requirement.length ; i++) {
            if (!this.checkRequirement(requirement[i])) {
              return false;
            }
          }
          return true;
        }
      }
    },
    stlMaterialSelection(selection) {
      if (this.$refs.uploader != null)
        return this.$refs.uploader.getMaterialSelection(selection);
    },
    previewImage(file) {
      if (file.meta && Array.isArray(file.meta.images) && file.meta.images.length) {
        return this.uploadUrl(file.type) + '/' + file.hash + ':' + file.token + '/' + file.meta.images[0] + '.png';
      }
      if (Array.isArray(file.images)) {
        return this.convertToRelative(file.imageUrl) + '/' + file.images[0] + '.png';
      }

      return 'void 0';
    },
    convertToRelative(x) {
      return x.indexOf('/api/project/') >= 0 ? '/api/project/' + x.split('/api/project/').pop() : x
    },
    openUploader() {
      this.$refs.uploader.reset();
      this.$parent.setPrevious(this.closeUploader);
      this.uploadStl = true;
    },
    closeUploader() {
      this.$parent.setPrevious('Projects');
      this.uploadStl = false;
    },
    updateConstruction(imgData, teeth, teethGroups) {

      this.$parent.setPrevious('Projects');
      this.editJaw = false;
      if (typeof imgData == 'string') {
        this.jawImage = imgData;
        this.teeth.teeth = teeth;
        this.teeth.groups = teethGroups;
        this.updatePrices(null, function() {
          // this.collectFileRequirements();
          this.updateRequirements();
        }.bind(this));
      }
      this.isModified = true;
      this.updateConstructionTabValidation()
    },
    openViewer(file, type) {
      const filename = file.name || file.filename || (file.fileHash + '.stl');
      const url = this.$root.url + 'project/' + this.projectId
              + '/' + (file.type || type)
              + '/' + (file.hash || file.fileHash) + (file.token ? ':' + file.token : '')
              + '/' + filename;

      this.$parent.openPreviewDialog(url, filename, false);
    },
    openJawEditor() {
      if (this.hasOrder) {
        return;
      }

      this.$refs.jawedit.reset();
      this.$parent.setPrevious(this.closeJawEditor);
      this.editJaw = true;
      setTimeout(function() {
        this.$refs.jawedit.load(JSON.parse(JSON.stringify(this.teeth.teeth)));
      }.bind(this), 1000);
    },
    closeJawEditor() {
      this.$parent.setPrevious('Projects');
      this.editJaw = false;
    },
    openAlert(title, text, style, icon) {
      this.alertTitle = title;
      this.alertText  = text ? text : '';
      this.alertStyle = style ? style : 'danger';
      this.alertIcon  = icon ? icon : '';
    },
    closeAlert() {
      this.alertTitle = '';
      this.alertText  = '';
      this.alertStyle = '';
      this.alertIcon  = '';
      this.alertOrder = '';
    },
    setProjectType(type) {
      this.type = type;

      var projectType = this.workflowType;

      if (projectType == null) {
        this.$root.sentry(function(Raven) {
          Raven.setExtraContext(res);
          Raven.captureMessage('Could not set project type: ' + type, {
            level: 'error'
          });
        }.bind(this));
        return;
      }

      for (var k in projectType) {
        if (projectType.hasOwnProperty(k)) {
          this[k] = JSON.parse(JSON.stringify(projectType[k]));
        }
      }

      Object.keys(this.orderForm).forEach(function(key) {
        if (typeof this.formValues[key] == 'undefined' && this.orderForm[key].defaultValue != 'undefined') {
          this.formValues[key] = this.orderForm[key].defaultValue;
        }
      }.bind(this));
    },
    uploadUrl(filetype) {
      return this.projectUrl + '/' + filetype;
    },
    handleChangeTab(tabId) {
      if (!this.isDynamicProject && this.isModified && !this.hasOrder) {
        this.saveProject(undefined, undefined, true);
      }

      const tabIds = this.tabs.map(({id}, index) => `${id || index}`);
      if (tabId === +1 || tabId === -1) {
        const current = tabIds.indexOf(this.activeTab);

        let invalid = false;
        let id = `tab_${this.activeTab || current}`;
        if (tabId === +1 && this.badges[id] && this.badges[id].valid === false) {
          this.badges[id].attempted = true;
          this.$forceUpdate();
          invalid = true;
        }

        id = `tab_form_${this.activeTab || current}`;
        if (tabId === +1 && this.badges[id] && this.badges[id].valid === false) {
          this.badges[id].attempted = true;
          this.$forceUpdate();
          invalid = true;
        }

        id = `tab_custom_${this.activeTab || current}`;
        if (tabId === +1 && this.badges[id] && this.badges[id].valid === false) {
          this.badges[id].attempted = true;
          this.$forceUpdate();
          invalid = true;
        }

        if (invalid) {
          this.scrollToInvalid();

          return;
        }

        tabId = tabIds[Math.min(Math.max(current + tabId, 0), tabIds.length)];
      }

      this.activeTab = tabIds.indexOf(tabId) >= 0 ? tabId : tabIds[0];

      const tab = this.tabs[tabIds.indexOf(this.activeTab)];

      if (tab.type === 'addons' && this.$refs.addons) {
        const [addons] = Array.isArray(this.$refs.addons) ? this.$refs.addons : [this.$refs.addons];
        addons && addons.refresh();
      }

      if (tab.type === 'cart') {
        this.updatePrices();
      }

      if (tab.type === 'stl') {
        this.updatePartTabValidation();
      }

      if (tab.type === 'construction') {
        this.updateConstructionTabValidation();
      }

      if (this.isDynamicProject) {
        this.$parent.updateUrl('ProjectDetails', this.$parent.viewIndex, tabId)
      } else {
        this.$parent.updateUrl('ProjectDetails', this.projectId, tabId)
      }
    },
    scrollToInvalid() {
      setTimeout(() => {
        const elems = window.document.querySelectorAll('.invalid');
        for (let elem of elems) {
          if (elem.offsetParent != null) {
            elem.scrollIntoView(true);
            if (window.innerWidth < 768) {
              window.scrollBy(0, -50);
            }
            break;
          }
        }
      }, 300);
    },
    handleAttachment(attachments, isInitialCall) {
      this.attachments = attachments;

      // When attachments are loaded for the first time, modification triggers should be suppressed
      if (isInitialCall !== true) {
        this.isModified = true;
        this.collectFileRequirements();
        this.updateRequirements();
      }

      this.formComplete = this.getFormStatus();
      this.$forceUpdate();
      this.isModified = true;

      this.revalidate();
    },
    revalidate() {
      (this.$refs.tab_content || []).forEach(x => typeof x.validate === 'function' ? x.validate() : x.$forceUpdate());
      this.workflowType.tabs.forEach(({id, validate}, index) => {
        if (typeof validate === 'function') {
          const value = validate(this);
          this.handleTabStatus(`tab_custom_${id || index}`, value === true, value);
        }
      })
    },
    handleAttachmentError(errMsg) {
      this.openAlert(errMsg);
    },
    handleFormInput(value, field, itemnum) {
      viewData.formValues[field.name] = value;
      viewData.itemNums[field.name] = itemnum;

      clearTimeout(this.handleFormInputTimeout);
      this.handleFormInputTimeout = setTimeout(() => {
      // if (this.getFieldItem(field, value)) {
        this.updatePrices();
        this.collectFileRequirements();
        this.updateRequirements();
        // return;
      // }
      }, 500);

      this.formComplete = this.getFormStatus();

      this.$forceUpdate();
      this.isModified = true;

      this.revalidate();
    },
    getFormStatus() {
      this.formComplete = true;
      for (var key in this.form) {
        if (
          this.form.hasOwnProperty(key) &&
          (typeof this.form[key].required != 'undefined') &&
          this.form[key].required &&
          this.meetsRequirements(this.form[key]) &&
          (
            (typeof this.formValues[key] == 'undefined') ||
            this.formValues[key] == null ||
            this.formValues[key] == ''
          )
        ) {
          return false;
        }
      }

      return true;
    },
    handleAddonItemClick(item) {
      this.$refs.newAddon.openItem(item);
    },
    handleRemoveAddon(item) {
      var addons = [];
      for (var i = 0 ; i < this.addons.length ; i++) {
        if (this.addons[i].itemnum != item.itemnum) {
          addons.push(this.addons[i]);
        }
      }

      this.addons = addons;
      this.$refs.newAddon.closeDialog();
      this.updatePrices();
      this.isModified = true;
    },
    handleNewAddon(item, replace) {
      const addon = this.addons.find(({itemnum: _}) => _ === item.itemnum);
      if (addon) {
        addon.amount = (replace ? 0 : parseInt(addon.amount, 10)) + parseInt(item.amount, 10);
      } else {
        this.addons.push({
            itemnum: item.itemnum,
            amount: parseInt(item.amount, 10),
          })
      }

      this.addons = [...this.addons];
      this.$refs.newAddon.closeDialog();
      this.updatePrices();
      this.isModified = true;
    },
    handleCartItemClick(item) {
      this.$refs.newAddon.openItem(item, item.amount);
    },
    handleCartItemUpdate(item) {
      this.handleNewAddon(item, true);
    },
    handleProjectAction(action) {
      this.handleChangeTab(+1);

      if (!this.badges['tab_form_approval'].valid) {
        this.scrollToInvalid();
        return
      }

      if (action.requiresComment && (this.formValues.customerComment || '').trim() === '') {
        alert(this.$t('ProjectDetails.warningRejectMessage'));
        return;
      }

      if (action.confirmation && !confirm(this.$t(action.confirmation))) {
        return;
      }

      this.requestApproval(action.id, action.path);
    },
    requestApproval(approved, path) {
      this.saveProject(() => {
        if (path) {
          this.$parent.resolveRoute(path);
        } else {
          this.$parent.openView('OrderDetails', this.reference.transaction.ID);
        }
      }, approved);
    },
    getProjectReference() {

    },
    changeAddress() {
      if (this.isModified) {
        if (window.confirm(this.$t('ProjectDetails.confirmSave'))) {
          this.saveProject(function () {
            this.$parent.openView('Addresses', this.projectId);
          }.bind(this));
        }
        return;
      }
      this.$parent.openView('Addresses', this.projectId);
    },
    getDownloadUrl(attachment) {
      return this.$root.restrictAttachmentDownload
              ? 'javascript: void(0)'
              : this.uploadUrl(attachment.type) + '/' + attachment.hash + ':' + attachment.token + '/' + attachment.filename;
    },
    getIconColor(attachment) {
      return util.fileIconColor(attachment.extension);
    },
    isImage(attachment) {
      return /\.(png|jpg|jpeg|gif)$/i.test(attachment.filename);
    },
    isStl(attachment) {
      return /\.stl$/i.test(attachment.filename);
    },
    handleToothSelectorChange(layer, values, teeth, teethGroups) {
      this.isModified = true;
      const original = typeof this.formValues[layer] === 'string' ? JSON.parse(this.formValues[layer]) : {};
      this.formValues[layer] = JSON.stringify(Object.assign(original, values));
      this.teeth.teeth = teeth;
      this.teeth.teethGroups = teethGroups;
      this.updatePrices(null, () => {
        this.collectFileRequirements();
        this.updateRequirements();

        this.formComplete = this.getFormStatus();
        this.$forceUpdate();
        this.isModified = true;

        (this.$refs.tab_content || []).forEach(x => typeof x.validate === 'function' ? x.validate() : x.$forceUpdate());
      })
    },
    handleFormStatus(tab, isValid) {
      this.badges[tab] = Object.assign({}, this.badges[tab], {
        valid: isValid,
        value: isValid ? '✔' : '!',
        color: isValid ? 'success' : 'warning',
      });

      if (this.badges.tab_cart) {
        delete this.badges.tab_cart.valid;
      }

      this.badges.tab_cart = {
        valid: this.readyToOrder(),
        color: this.readyToOrder() ? 'success' : 'warning',
        value: this.cartItemCount(),
      }

      this.$forceUpdate();
    },
    handleTabStatus(tab, isValid, message) {
      if (tab !== 'tab_cart') {
        this.badges[tab] = {
          valid: isValid,
          value: isValid ? '✔' : '!',
          color: isValid ? 'success' : 'warning',
          message,
        }
      }

      if (this.badges.tab_cart) {
        delete this.badges.tab_cart.valid;
      }

      this.badges.tab_cart = {
        valid: this.readyToOrder(),
        color: this.readyToOrder() ? 'success' : 'warning',
        value: this.cartItemCount(),
      }

      if (this.workflowType.tabs.some(({type}) => type === 'stl')) {
        this.updatePartTabValidation();
      }

      if (this.workflowType.tabs.some(({type}) => type === 'construction')) {
        this.updateConstructionTabValidation();
      }

      this.$forceUpdate();
    },
    getTabClass({type}, id) {
      return [
        type === 'cart' ? 'nopadding' : '',
        ((this.badges[`tab_${id}`] || {}).attempted || (this.badges[`tab_form_${id}`] || {}).attempted || (this.badges[`tab_custom_${id}`] || {}).attempted) ? 'validation-forced' : 'non-validated',
      ].filter(x => x).join(' ');
    }
  }
});
</script>
<style>
.cart-loader-container {
  min-height: 150px;
  display: block;
  opacity: .6;
}
.fileicon {
  display: inline-block;
  color: white;
  padding: 5px;
  text-transform: uppercase;
}
.attachment-filename {
  text-align: center;
  max-width: 135px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attachment-item {
    display: inline-block;
}
.fileicon-cnt {
  text-align: center;
  vertical-align: middle;
  width: 120px;
  height: 90px;
  margin: 10px;
  padding: 5px;
  line-height: 90px;
  box-shadow: 0 0 2px 1px rgba(0,0,0,.1);
  border-radius: 2px;
}

.fileicon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.nav-buttons-container {
  margin-top: 16px;
}

.nopadding > .nav-buttons-container {
  margin: 0 16px;
}

.non-validated .alert.alert-danger {
  display: none;
}

.btn[data-balloon] {
  outline: none !important;
}
</style>
